/**
 * Centralized API configuration
 * 
 * To change the backend URL, update REACT_APP_API_URL in your .env file
 * or modify the default value below.
 * 
 * For development with proxy: use empty string or '/api'
 * For direct connection: use 'http://localhost:5000'
 */

// Get API base URL from environment variable, or use default
const getApiBaseUrl = () => {
  // If REACT_APP_API_URL is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Default: use relative URLs (works with proxy in package.json)
  // Change this if you need to use absolute URLs
  return '';
};

// Export the API base URL
export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API URLs
export const getApiUrl = (endpoint) => {
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  
  if (API_BASE_URL) {
    // If base URL is set, ensure it doesn't end with slash
    const base = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
    return `${base}/${cleanEndpoint}`;
  }
  
  // Return relative URL (will use proxy)
  return `/${cleanEndpoint}`;
};

// Backend port (for error messages and fallback URLs)
export const BACKEND_PORT = process.env.REACT_APP_BACKEND_PORT || '5000';

// Backend host (for absolute URLs when needed)
export const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST || 'localhost';

// Full backend URL (for absolute URLs)
export const BACKEND_URL = `http://${BACKEND_HOST}:${BACKEND_PORT}`;

export default {
  API_BASE_URL,
  getApiUrl,
  BACKEND_PORT,
  BACKEND_HOST,
  BACKEND_URL,
};
